import React from 'react';
import PropTypes from 'prop-types';

import FormatGraphDataService from 'components/year-review/services/FormatGraphDataService';

const YRTooltip = ({
    active, payload, prefix, suffix, dataNames,
}) => {
    if (active) {
        const data = payload[0].payload;

        return (
            <div className="yr-tooltip">
                <div>
                    {
                        dataNames.length ?
                            dataNames.map((dataName, index) => (
                                <span key={dataName}>
                                    <strong>{dataName}: </strong>
                                    {Number.isInteger(data[`values${index}`])
                                        ? FormatGraphDataService.addCommas(data[`values${index}`])
                                        : FormatGraphDataService.twoDecimalPlaces(data[`values${index}`])
                                    }
                                    {suffix}
                                    <br />
                                </span>))
                            :
                            (
                                <strong>
                                    {Number.isInteger(data.values)
                                        ? FormatGraphDataService.addCommas(data.values)
                                        : FormatGraphDataService.twoDecimalPlaces(data.values)}
                                    {` ${suffix}`}
                                </strong>
                            )
                    }
                </div>
                <div>{prefix} {data.name}</div>
            </div>
        );
    }
    return null;
};


YRTooltip.defaultProps = {
    payload: [],
    prefix: '',
    suffix: '',
    active: false,
    dataNames: [],
};

YRTooltip.propTypes = {
    active: PropTypes.bool,
    payload: PropTypes.arrayOf(PropTypes.object),
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    dataNames: PropTypes.arrayOf(PropTypes.string),
};

export default YRTooltip;
